var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.productAttribute)?_c('div',{class:[_vm.productAttribute.class, 'product-attribute']},[_vm._v("\n  "+_vm._s(_vm.productAttribute.text)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }